export const adCards = [
  {
    image: "/assets/platforms/meta/awareness.jpg",
    badge: "AWARENESS",
    copy: "Stop wasting budget. Let AI write copy that converts on Meta.",
    cta: "Learn More",
    note: "Try Imagive Free",
  },
  {
    image: "/assets/platforms/meta/retargeting.jpg",
    badge: "RETARGETING",
    copy: "Your competitors use AI copy. Here's how to beat them on every scroll.",
    cta: "Shop Now",
    note: "Start Free No Card Needed",

    featured: true,
  },

  {
    image: "/assets/platforms/meta/conversion.jpg",
    badge: "CONVERSION",
    copy: "Hook → Story → Offer. Meta-native formats that stop the scroll.",
    cta: "Shop Now",
    note: "Generate 50 Variants Now",
  },
];

export const heroStats = [
  {
    value: "4.2×",
    title: "Average ROAS lift",
    sub: "vs. manually written copy",
  },
  { value: "50+", title: "Ad variants", sub: "generated per campaign" },
  { value: "3 min", title: "Time to launch", sub: "from brief to live copy" },
  {
    value: "98%",
    title: "Policy compliance",
    sub: "built-in format validation",
  },
];

export const launchSteps = [
  {
    step: "01",
    title: "Describe your campaign",
    description:
      "Tell Imagive your product, target audience, funnel stage, and tone. Takes under 60 seconds.",
  },
  {
    step: "02",
    title: "AI generates variations",
    description:
      "Get 50+ Meta-optimized copy variants primary text, headlines, CTAs instantly across all formats.",
  },
  {
    step: "03",
    title: "Pick, edit, and launch",
    description:
      "Select favorites, refine inline, and export directly to Meta Ads Manager or your clipboard.",
  },
];

export const featureTabs = [
  {
    id: "meta-ready",
    tab: { icon: "⚡", label: "Meta-Ready Variations" },
    badge: "Meta-Ready Variations",
    heading: "Every format Meta supports, instantly.",
    description:
      "Generate primary text, headlines, descriptions, and link copy - all aligned to Meta's character limits and best practices. Imagive knows what performs in feeds, stories, and reels so you don't have to guess.",
    checklist: [
      "Primary text up to 125 chars",
      "Headline + sub-headline pairs",
      "Story-native short-form copy",
      "Reel hook lines",
    ],
    cta: "Try this feature free",
    // right-side preview: an ad-composer form
    preview: {
      type: "form",
      fields: [
        {
          label: "PRIMARY TEXT",
          count: "89/125",
          text: "Stop guessing what converts. Let AI write your next winning Meta ad in 30 seconds.",
        },
        {
          label: "HEADLINE",
          count: "31/40",
          text: "AI Copy That Actually Converts",
        },
        {
          label: "DESCRIPTION",
          count: "34/30",
          overLimit: true,
          text: "Try Imagive free no credit card.",
        },
        {
          label: "CTA",
          text: "Learn More",
        },
      ],
      button: "Generate 50 More Variations",
      href: "https://app.imagive.ai?redirect=/users/white-chat-board",
    },
  },
  {
    id: "funnel-persona",
    tab: { icon: "🎯", label: "Funnel & Persona Targeting" },
    badge: "Funnel & Persona Targeting",
    heading: "Different copy for every stage of the funnel.",
    description:
      "Imagive writes awareness copy that educates, retargeting copy that nudges, and conversion copy that closes each calibrated to the psychological state of your audience.",
    checklist: [
      "TOFU / MOFU / BOFU modes",
      "Persona-aware tone shifting",
      "Pain-point and desire mapping",
      "Urgency and scarcity variants",
    ],
    cta: "Try this feature free",
    // right-side preview: funnel-stage cards
    preview: {
      type: "cards",
      cards: [
        {
          tag: "TOFU · AWARENESS",
          tone: "tofu",
          text: "Ever wonder why your Meta ads feel generic? AI-powered copy fixes that.",
        },
        {
          tag: "MOFU · RETARGETING",
          tone: "mofu",
          text: "You checked out Imagive. Ready to see what AI copy can do for your ROAS?",
        },
        {
          tag: "BOFU · CONVERSION",
          tone: "bofu",
          text: "Limited offer: 3 months of Imagive Pro, free. Start generating today.",
        },
      ],
    },
  },
  {
    id: "scroll-behavior",
    tab: { icon: "📱", label: "Built for Scroll Behavior" },
    badge: "Built For Scroll Behavior",
    heading: "Copy engineered for 0.8-second attention spans.",
    description:
      "Meta feeds move fast. Imagive generates hooks that interrupt the scroll, micro-stories that hold attention, and offers that create urgency within the constraints of a thumb-stopping mobile environment.",
    checklist: [
      "Open-loop hooks",
      "Curiosity-gap sentences",
      "Pattern interrupts",
      "Mobile-first character pacing",
    ],
    cta: "Try this feature free",
    // right-side preview: scroll hook generator list
    preview: {
      type: "list",
      title: "Scroll Hook Generator",
      items: [
        {
          label: "OPEN LOOP",
          text: "The reason your Meta ads aren't converting has nothing to do with your creative…",
        },
        {
          label: "PATTERN INTERRUPT",
          text: "Warning: Do NOT run another Meta ad before reading this.",
        },
        {
          label: "CURIOSITY GAP",
          text: "We analyzed 10,000 high-CTR Meta ads. This element showed up in 94% of them.",
        },
        {
          label: "SOCIAL PROOF",
          text: "This 3-sentence Meta ad generated $240k in 30 days. Here's the copy.",
        },
      ],
    },
  },
  {
    id: "tested-formats",
    tab: { icon: "🧪", label: "Meta-Tested Formats" },
    badge: "Meta-Tested Formats",
    heading: "Proven frameworks. Infinite variations.",
    description:
      "Imagive is trained on top-performing Meta ad structures. Hook-Story-Offer, PAS, AIDA, and UGC-style copy come pre-loaded, so every output follows a framework that has a track record.",
    checklist: [
      "Hook-Story-Offer (HSO)",
      "Problem-Agitate-Solution (PAS)",
      "AIDA framework",
      "UGC-inspired authentic voice",
    ],
    cta: "Try this feature free",
    // right-side preview: framework example cards
    preview: {
      type: "items",
      items: [
        {
          tag: "HSO",
          tagLabel: "Hook-Story-Offer",
          tone: "hso",
          text: "💰 I spent $50k on Meta ads before I found this. Our ROAS was 0.8× and sinking. Then we switched to AI copy. Now we hit 4.2× ROAS consistently. Start free →",
        },
        {
          tag: "PAS",
          tagLabel: "Problem-Agitate-Solution",
          tone: "pas",
          text: "Your Meta ads are getting ignored. Every scroll is a missed conversion, a wasted dollar. Imagive writes copy that makes them stop. Generate your first ad free.",
        },
      ],
    },
  },
];
